export const MIN_SAFE_INTEGER = Number.MIN_SAFE_INTEGER